import store from '@/store/'

export default function verify({ next, to }) {
  if (store.getters['auth/is_auth']) {
    to.meta.layout = 'app-layout'
  }
  return next()
}
